export function getClinicianAssessmentScores(config = {}, answers = {}) {
	const assessment = config.assessment || {}
	const scores = {}
	const missingItems = []
	for (const item of assessment.items || []) {
		const value = answers[item.fieldId]
		const selected = typeof value === "string" ? item.anchors?.findIndex((anchor, index) => value === `${index} — ${anchor}`) : value
		const rating = Number.isInteger(selected) && selected >= 0 && selected < (item.anchors?.length || 0) ? selected : null
		scores[item.fieldId] = rating
		if (rating === null) missingItems.push(item.number || item.fieldId)
	}
	const subtotals = {}
	for (const group of assessment.ratingGroups || []) {
		const ratings = (group.itemIds || []).map(id => scores[id])
		subtotals[group.id] = ratings.every(value => value !== null && value !== undefined) ? ratings.reduce((sum, value) => sum + value, 0) : null
	}
	const values = Object.values(subtotals)
	const total = values.length && values.every(value => value !== null) ? values.reduce((sum, value) => sum + value, 0) : null
	const missingDomains = (assessment.domains || []).filter(domain => answers[domain.reviewedFieldId] !== "Reviewed").map(domain => `${domain.type}: ${domain.title}`)
	return {subtotals, total, missingItems, missingDomains}
}

export function preserveClinicianChecklistSelections(config = {}, payload = {}) {
	const answers = {...payload.answers}
	for (const domain of config.assessment?.domains || []) {
		for (const fieldId of [domain.currentFieldId, domain.pastFieldId, domain.principalFieldId].filter(Boolean)) {
			const field = (payload.form?.fields || []).find(candidate => candidate.id === fieldId)
			if (field) answers[fieldId] = (field.checkboxAnswers || []).map(index => field.answerOptions[index]).filter(Boolean)
		}
	}
	return {...payload, answers}
}

export function createClinicianAssessmentFormSnapshot(form = {}) {
	return {
		...form,
		fields: (form.fields || []).map(field => ({...field, answer: "", checkboxAnswers: [], selectedIndex: -1, otherAnswer: ""})),
	}
}

export function normalizeClinicianAssessmentRatings(config = {}, payload = {}) {
	const answers = {...payload.answers}
	for (const item of config.assessment?.items || []) {
		const answer = answers[item.fieldId]
		if (typeof answer === "string") {
			const index = item.anchors.findIndex((anchor, rating) => answer === `${rating} — ${anchor}`)
			if (index >= 0) answers[item.fieldId] = index
		}
	}
	return {...payload, answers}
}

export function createClinicianAssessmentDisplayPayload(config = {}, payload = {}) {
	const answers = {...payload.answers}
	for (const item of config.assessment?.items || []) {
		const rating = answers[item.fieldId]
		if (Number.isInteger(rating) && rating >= 0 && rating < item.anchors.length) {
			answers[item.fieldId] = `${rating} — ${item.anchors[rating]}`
		}
	}
	return {...payload, answers}
}

export function getClinicianAssessmentGroups(config = {}) {
	const domains = config.assessment?.domains || []
	return [...new Set(domains.map(domain => domain.type))].map(type => ({type, domains: domains.filter(domain => domain.type === type)}))
}

export function getClinicianAssessmentSymptomText(domain, period, answers = {}) {
	const fieldId = period === "Current" ? domain.currentFieldId : domain.pastFieldId
	const selection = answers[fieldId]
	return Array.isArray(selection) && selection.length ? selection.join("; ") : selection || (answers[domain.reviewedFieldId] === "Reviewed" ? "None endorsed" : "Not reviewed")
}

export function getClinicianAssessmentTargets(type, config = {}, answers = {}) {
	const group = (config.assessment?.targetGroups || []).find(candidate => candidate.type === type)
	return (group?.fieldIds || []).map(fieldId => answers[fieldId]).filter(Boolean).join("; ") || "None recorded"
}
